/**
 * Quiz CTA — Marquee
 * rAF-driven horizontal scroll on `.oddit-section-quiz-cta__marquee-track`.
 * Speed is read from `data-marquee-speed` (px/s) on the wrapper element.
 * Supports theme-editor load/unload lifecycle and prefers-reduced-motion.
 */
;(function () {
  var DEFAULT_SPEED = 80 // px/s

  function initMarquee(wrapper) {
    var track = wrapper.querySelector('.oddit-section-quiz-cta__marquee-track')
    if (!track) return

    var speed = parseFloat(wrapper.dataset.marqueeSpeed) || DEFAULT_SPEED
    var offsetPx = 0
    var segmentWidth = 0
    var rafId = null
    var lastTs = null
    var paused = false
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)')

    function measure() {
      // Track contains two identical sequences; half its scroll width is one segment.
      var full = track.scrollWidth
      segmentWidth = full / 2
    }

    function tick(ts) {
      if (!lastTs) lastTs = ts
      var delta = ts - lastTs
      lastTs = ts

      if (!paused && segmentWidth > 0) {
        offsetPx += speed * (delta / 1000)
        if (offsetPx >= segmentWidth) offsetPx -= segmentWidth
        track.style.transform = 'translate3d(' + (-offsetPx) + 'px, 0, 0)'
      }

      rafId = requestAnimationFrame(tick)
    }

    function start() {
      if (reducedMotion.matches) return
      track.classList.add('oddit-section-quiz-cta__marquee-track--running')
      lastTs = null
      rafId = requestAnimationFrame(tick)
    }

    function stop() {
      if (rafId) {
        cancelAnimationFrame(rafId)
        rafId = null
      }
      lastTs = null
      track.classList.remove('oddit-section-quiz-cta__marquee-track--running')
    }

    // Pause on hover / focus so keyboard users can read without motion.
    function handlePauseEnter() { paused = true }
    function handlePauseLeave() { paused = false }

    wrapper.addEventListener('pointerenter', handlePauseEnter)
    wrapper.addEventListener('pointerleave', handlePauseLeave)
    wrapper.addEventListener('focusin', handlePauseEnter)
    wrapper.addEventListener('focusout', handlePauseLeave)

    // Recalculate on resize (breakpoint changes alter image widths).
    var resizeObserver = new ResizeObserver(function () {
      measure()
      // Reset offset to avoid overshooting after a shrink.
      if (segmentWidth > 0 && offsetPx > segmentWidth) offsetPx = offsetPx % segmentWidth
    })
    resizeObserver.observe(track)

    // Wait for images to paint before taking first measurement.
    if (document.readyState === 'complete') {
      measure()
      start()
    } else {
      window.addEventListener('load', function () {
        measure()
        start()
      }, { once: true })
    }

    // Honour reduced-motion changes dynamically (e.g. OS setting toggle).
    function handleReducedMotion(e) {
      if (e.matches) {
        stop()
        track.style.transform = ''
        offsetPx = 0
      } else {
        measure()
        start()
      }
    }
    reducedMotion.addEventListener('change', handleReducedMotion)

    // Cleanup stored on the wrapper for theme-editor unload.
    wrapper._odditQuizCtaCleanup = function () {
      stop()
      resizeObserver.disconnect()
      reducedMotion.removeEventListener('change', handleReducedMotion)
      wrapper.removeEventListener('pointerenter', handlePauseEnter)
      wrapper.removeEventListener('pointerleave', handlePauseLeave)
      wrapper.removeEventListener('focusin', handlePauseEnter)
      wrapper.removeEventListener('focusout', handlePauseLeave)
      track.style.transform = ''
    }
  }

  function init(root) {
    var scope = root || document
    var wrappers = scope.querySelectorAll('[data-oddit-quiz-cta-marquee]')
    wrappers.forEach(initMarquee)
  }

  // Boot
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init() })
  } else {
    init()
  }

  // Theme editor
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target)
  })

  document.addEventListener('shopify:section:unload', function (e) {
    var wrappers = e.target.querySelectorAll('[data-oddit-quiz-cta-marquee]')
    wrappers.forEach(function (w) {
      if (typeof w._odditQuizCtaCleanup === 'function') w._odditQuizCtaCleanup()
    })
  })
})()
